/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { createRoot } from 'react-dom/client'
import { DemoDeck } from './demos/DemoDeck.tsx'
import { WaitlistForm } from './components/WaitlistForm.tsx'

/**
 * Home page client entry.
 *
 * The page is server-rendered by Hono and stays readable without JS; React
 * hydrates only the two interactive islands. Each mount is guarded so a
 * missing node (or a failure in one island) never takes the other down.
 */

function mount(id: string, node: React.ReactNode) {
  const el = document.getElementById(id)
  if (!el) return
  try {
    createRoot(el).render(node)
  } catch (err) {
    console.error(`[monkeyplex] failed to mount #${id}`, err)
  }
}

mount('demos-root', <DemoDeck />)
mount('waitlist-root', <WaitlistForm />)
